import { useEffect, useState } from 'react';
import { marketSession, msToNextSessionChange } from '../utils/session';

/**
 * The current market session ('weekend' | 'pre' | 'regular' | 'post'), kept
 * current: it flips within about a second of 09:30 / 16:00 ET and when a tab or
 * a slept laptop comes back, and costs one timer per boundary (never a poll).
 *
 * Only for what the screen shows. Whether a price frame may be applied is
 * decided from the clock at the moment it arrives (see admitPriceUpdate), not
 * from this value, which can trail by the timer's slack.
 */
export default function useMarketSession() {
  const [session, setSession] = useState(() => marketSession());

  useEffect(() => {
    let timer = null;
    const refresh = () => {
      clearTimeout(timer);
      setSession(marketSession()); // same value: React skips the render
      timer = setTimeout(refresh, msToNextSessionChange());
    };
    refresh();
    // Timers in a hidden tab are throttled and stop entirely while a laptop sleeps.
    document.addEventListener('visibilitychange', refresh);
    return () => {
      clearTimeout(timer);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, []);

  return session;
}
